import { useTranslation } from 'react-i18next'
import React from 'react'

import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../../EditableSentence'
import Text from '../../../../../../packages/kiti/components/presentation/Text'
import NumberInput from '../../../../../../packages/kiti/components/form/NumberInput'

const CompleteNonCompliancesSentence = () => {
      const { t } = useTranslation('triggers')
      const { form, handleChangeIn } = useFormState()

      return (
            <>
                  <Text size="h2"> {t('completeNonCompliances.moreThan')} </Text>
                  <EditableSentence
                        label={form.payload?.days ? form.payload?.days : '_____'}
                        value={form.payload?.days}
                        Input={NumberInput}
                        field="payload"
                        disableCloseOnChange
                        onlyInt
                        onChange={handleChangeIn(['payload', 'days'])}
                  />
                  <Text size="h2"> {t('completeNonCompliances.days')} </Text>
            </>
      )
}

export default CompleteNonCompliancesSentence
